export const clientsEn = {
  pageTitle: 'Clients',
  showPastClients: 'All',
  hidePastClients: 'Active',
  showPastClientsLabel: 'Show past clients',
  filteredOutPast: 'No active clients. Toggle to show clients with only past trips.',
  addClient: 'Add client',
  goToListBuilder: 'List Builder',
  listBuilderDescription: 'Manage your cities, activities, meals, and hotels. Preload your knowledge so it\'s ready when planning itineraries.',
  noClients: 'No clients yet.',
  noClientsDescription: 'Add your first client to get started.',
  columns: {
    name: 'Name',
    dates: 'Next trip',
    trips: 'Trips',
  },
  tripDates: (start: string | null, end: string | null): string => {
    if (!start && !end) return '—';
    if (start && end) return `${start} – ${end}`;
    return start || end || '—';
  },
} as const;
